import { LetterEventName, logLetterEvent } from "../../helpers/logLetterEvent";

import { LetterError } from "../../components/FinalStep/LetterError";
import { LetterLoading } from "../../components/FinalStep/LetterLoading";
import { LetterSuccess } from "../../components/FinalStep/LetterSuccess";
import ROUTES from "src/js/router/routes";
import { clearStore as clearLetterStore } from "src/js/stores/letter/actions";
import { letterStore } from "src/js/stores/letter/store";
import { router } from "src/js/router/react-router";
import { siteStore } from "src/js/stores/site/store";
import { useLetterCreator } from "../../../hooks/useLetterCreator/useLetterCreator";
import { useSnapshot } from "valtio";

export const DownloadLetter = () => {
  const { siteCardId } = useSnapshot(siteStore);
  const { selectedStageIds, selectedSiteIds } = useSnapshot(letterStore);

  const { loading, error } = useLetterCreator();

  const handleNavigateToLettersTab = () => {
    logLetterEvent({
      name: LetterEventName.LETTERS_FORM_FINISH_STEP_VIEW_LETTERS_BUTTON_CLICKED,
    });
    clearLetterStore();
    router.push({
      name: ROUTES.SITES,
      ...(siteCardId && {
        query: {
          card_page: "letters",
          site_id: siteCardId,
        },
      }),
    });
  };

  const handleNavigateToLetterBatches = () => {
    logLetterEvent({
      name: LetterEventName.LETTERS_FORM_FINISH_STEP_VIEW_LETTER_CAMPAIGNS_BUTTON_CLICKED,
    });
    clearLetterStore();
    router.push({
      name: ROUTES.LETTERS_BATCHES,
    });
  };

  const handleGoToSites = () => {
    logLetterEvent({
      name: LetterEventName.LETTERS_FORM_FINISH_STEP_GO_TO_SAVED_SITES_BUTTON_CLICKED,
    });
    clearLetterStore();
    router.push({
      name: ROUTES.SITES,
    });
  };

  if (loading) {
    return <LetterLoading />;
  } else if (error) {
    return (
      <LetterError
        onBackClick={
          selectedStageIds?.length && !selectedSiteIds?.length ? handleGoToSites : handleNavigateToLettersTab
        }
      />
    );
  } else {
    return (
      <LetterSuccess
        onViewLettersClick={
          selectedStageIds?.length && !selectedSiteIds?.length
            ? handleNavigateToLetterBatches
            : handleNavigateToLettersTab
        }
        onGoToSitesClick={handleGoToSites}
      />
    );
  }
};
